import {Vue, Component} from "vue-property-decorator";
import qs from "query-string";
import {FilterOperator} from "@/models/FilterOperator";
import dayjs from "dayjs";

enum WDStatus {
  New = "new",
  Open = "open",
  Closed = "closed",
  Error = "error",
}

@Component
export default class IndexMixin extends Vue {

  get WDStatus() {
    return WDStatus;
  }

  get activeWD() {
    return this.$store.state.app.closed_day;
  }

  /**
   * Just to check that the working day is today
   */
  get isOpen() {
    return this.currentWDStatus == WDStatus.Open;
  }

  get isClosed() {
    return !this.isOpen;
  }

  public get currentWDStatus() {
    // opened and already closed
    const wd = this.activeWD;
    if (wd.open_by && wd.closed_by) {
      return WDStatus.Closed;
    }

    // opened and unclosed <= it means Open
    if (wd.open_by && !wd.closed_by) {
      return WDStatus.Open;
    }

    // Impossible,
    if (!wd.open_by && !wd.closed_by) {
      return WDStatus.New;
    }

    // closed detected but never open on the last working day
    return WDStatus.Error;
  }

  /**
   * If outlet status is open the show close
   * and vice versa
   */
  get switchString(): string {
    return this.isOpen ? "Close " : "Open ";
  }

  public byOutletId(outletId): string {
    const params = qs.stringify(
      {
        filter_by: ["outlet_id"],
        filter_by_value: [outletId],
        filter_by_operator: [FilterOperator.Equal],
      },
      { arrayFormat: "bracket" }
    );
    return params;
  }

  public getUid(token) {
    if (token?.uid) {
      return token.uid;
    }
    return "";
  }

  public strDate(tDate:Date, format:number = 0) {

    if (!tDate)
      return "";
    if (format == 0)
      return dayjs(tDate).format("DD MMM YYYY HH:mm:ss");
    return dayjs(tDate).fromNow(true);
  }
}
